import { axiosInstanceBatchCredit } from "../axios";
import {
  AgentCreate,
  AgentCreations,
  DestinationAccounts,
  RequestResponse
} from "../types";

export const createAgent = async (
  payload: AgentCreate
): Promise<RequestResponse> => {
  try {
    await axiosInstanceBatchCredit.post("/api/institutions", payload);
    return {
      error: false,
      data: null
    };
  } catch (err) {
    console.error("Unable to create agent: ", err);
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};

export const createDestinationAccount = async (
  payload: DestinationAccounts
): Promise<RequestResponse> => {
  try {
    await axiosInstanceBatchCredit.put(
      "/api/institutions/add-accounts",
      payload
    );
    return {
      error: false,
      data: null
    };
  } catch (err) {
    console.error("Unable to create agent: ", err);
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};

export const getAgents = async (
  pageNumber: number,
  pageSize: number,
  appId: string,
  institutionId: string,
  merchantCode: string,
  acquirer: string
): Promise<
  RequestResponse<{
    records: AgentCreations[];
    total: number;
    responseCode: string;
    responseMessage: string;
  }>
> => {
  try {
    const params: any = {
      page: pageNumber,
      size: pageSize
    };

    if (appId) params.appId = appId;
    if (institutionId) params.institutionId = institutionId;
    if (merchantCode) params.merchantCode = merchantCode;
    if (acquirer) params.acquirer = acquirer;

    const response = await axiosInstanceBatchCredit.get(
      "/api/institutions/all",
      {
        params
      }
    );

    return {
      error: false,
      data: {
        records: response.data.data,
        total: response.data.count,
        responseCode: response.data.responseCode,
        responseMessage: response.data.responseMessage
      }
    };
  } catch (err) {
    console.error("Unable to fetch agents: ", err);
    const errorResponse = err.response?.data;
    return {
      error: true,
      message:
        errorResponse?.responseMessage ||
        errorResponse?.message ||
        err.message ||
        err,
      data: errorResponse || null
    };
  }
};

export const updateAgent = async (
  id: number,
  payload: AgentCreate
): Promise<RequestResponse> => {
  try {
    const updatedPayload = {
      id,
      ...payload
    };
    await axiosInstanceBatchCredit.put(`/api/institutions`, updatedPayload);
    return {
      error: false,
      data: null
    };
  } catch (err) {
    console.error("Unable to update agent: ", err);
    return {
      error: true,
      message: err.response?.data.responseMessage,
      data: err.response?.data || null
    };
  }
};
